// The shell shown before the board: loading, signing in, or refused.

import type { ReactNode } from 'react';

export function Gate({ message, children }: { message?: string; children?: ReactNode }) {
  return (
    <div className="gate">
      <p className="eyebrow">Cartesia · GTM</p>
      <h1>Opportunities <span className="masthead-accent">Dashboard</span></h1>
      {message ? <p className="gate-message">{message}</p> : null}
      {children}
    </div>
  );
}

// Signed in and verified, but not in this app's roles.json. Signing in again changes nothing, so
// this offers sign-out, not the sign-in form: it's the only way out of the wrong account.
export function DeniedGate({
  message, email, onSignOut,
}: {
  message: string;
  email: string | null;
  onSignOut: () => void;
}) {
  return (
    <Gate>
      <div className="notice notice-error">
        <b>You don't have access to this board.</b>
        <br />
        {message}
      </div>
      {email ? <p className="gate-message">Signed in as {email}.</p> : null}
      <button className="button" onClick={onSignOut}>Sign out</button>
    </Gate>
  );
}
